import create_app from "workflow/vue/3/create_app"

export default app => {
    if (!app.render) app.render = () => null // disable vue warning for missing render function
    return create_app({ app, el: document.createElement("div") })
}
